module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/18mill-active-fb372c6fc4cb7915ed4c5b89e0916e94.png";